export default function Space() {
  return {}
}
